import React from 'react';

const VillaSection = () => {
  return (
    <div className="bg-black py-20 px-6" data-testid="villa-section">
      <div className="max-w-6xl mx-auto">
        
        {/* Main content - Photo + Text */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          
          {/* Photo */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img 
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_c9f8c8c9-6f95-436f-97e4-46853bac1308/artifacts/jni1sae8_ef.jpeg"
                alt="Secret Camp - Essaouira"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-4 bg-[#D4A574] text-white px-6 py-3 rounded-xl shadow-2xl">
              <p className="text-xs tracking-wider font-medium">ESSAOUIRA, MAROC</p>
            </div>
          </div>

          {/* Text */}
          <div className="lg:pl-8">
            <p className="text-[#D4A574] text-[10px] tracking-[0.4em] mb-4">LE QG</p>
            <h2 className="font-italiana text-3xl md:text-4xl lg:text-5xl text-white tracking-[0.05em] uppercase mb-6 leading-tight">
              Secret Camp<br/>
              <span className="text-[#D4A574]">Ton camp de base</span>
            </h2>
            
            <div className="space-y-4 text-white/70 text-base leading-relaxed">
              <p>
                <span className="text-white font-medium">Une villa privée face à l'océan Atlantique.</span> Piscine, hammam, terrasses infinies. Ton sanctuaire pour les 6 prochains jours.
              </p>
              <p>
                Ici, pas de touristes. Pas de distractions. Juste <span className="text-[#D4A574]">10-12 entrepreneurs</span> qui viennent <span className="text-white">décupler leur énergie, leur réseau et leur business.</span>
              </p>
              <p>
                Le matin, tu te réveilles avec le son des vagues. Tu repousses tes limites physiques. L'après-midi, tu structures ta croissance. Le soir, tu crées des liens pour la vie.
              </p>
            </div>

            {/* Key points */}
            <div className="grid grid-cols-2 gap-4 mt-8">
              <div className="bg-white/5 rounded-xl p-4 border border-white/10">
                <p className="text-[#D4A574] text-2xl font-italiana mb-1">100%</p>
                <p className="text-white/50 text-xs">Privatisé pour toi</p>
              </div>
              <div className="bg-white/5 rounded-xl p-4 border border-white/10">
                <p className="text-[#D4A574] text-2xl font-italiana mb-1">6</p>
                <p className="text-white/50 text-xs">Nuits all-inclusive</p>
              </div>
            </div>

            {/* Quote */}
            <div className="mt-8 border-l-2 border-[#D4A574] pl-6">
              <p className="text-white/60 italic text-sm">
                "Train. Work. Eat. Recover. Network.<br/>
                <span className="text-white">No vegan. No limit. Just men.</span>"
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default VillaSection;
